import React, { Component } from 'react';
import axios from 'axios';
import config from '../config';
import DetailView from '../views/DetailView';
import { withError, withRouter, Loading , HandleLoading} from 'cw-styleguide-react';
import i18n from '../i18n';
import OptionsContext from '../contexts/options';

class DetailController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingApprenticeship: null,
      id: '',
      status: '',
      title: '',
      location: '',
      level: 0,
      slug: '',
      pay: '',
      closing: '',
      hours: 0,
      positions: 0,
      aboutDuties: '',
      aboutAdditionalInformation: '',
      requirementsDesirableQualifications: '',
      requirementsRequiredQualifications: '',
      requirementsSkills: '',
      requirementsWelshSpoken: false,
      requirementsWelshWritten: false,
      trainingProvider: '',
      trainingQualification: '',
      disabilityConfident: false,
      employerName: '',
      employerCountryCode: '',
      employerLocality: '',
      employerPostalCode: '',
      employerAddressLine1: '',
      employerAddressLine2: '',
      employerOrganisation: '',
      employerMap: '',
      applicationUrl: '',
      applicationEmail: '',
      applicationFormat: '',
      applicationInstructions: '',
      interview: ''
    };
  }

  componentDidMount() {


    this.getApprenticeship(this.props.params.apprenticeship)
      .then(response => {
        this.setState({
          isLoadingApprenticeship: true,
          id: response.data.id,
          status: response.data.status,
          title: response.data.title,
          level: this.context.apprenticeshipLevels.find(level => level.value === response.data.apprenticeshipLevel.toString())?.name,
          slug: response.data.slug,
          pay: response.data.pay,
          closing: response.data.closingDate,
          hours: this.context.hours.find(hours => hours.value === response.data.hours.toString())?.name,
          positions: response.data.positions,
          aboutDuties: response.data.about.duties,
          aboutAdditionalInformation: response.data.about.additionalInformation,
          requirementsDesirableQualifications: response.data.requirements.desirableQualifications,
          requirementsRequiredQualifications: response.data.requirements.requiredQualifications,
          requirementsSkills: response.data.requirements.skills,
          requirementsWelshSpoken: response.data.requirements.welshLanguage.welshSpoken,
          requirementsWelshWritten: response.data.requirements.welshLanguage.welshWritten,
          trainingProvider: response.data.training.trainingProvider,
          trainingQualification: response.data.training.trainingProviderCourse,
          disabilityConfident: response.data.apprenticeshipDisabilityConfident,
          employerName: response.data.employerDetails.name,
          employerCountryCode: response.data.employerDetails.address.country_code,
          employerLocality: response.data.employerDetails.address.locality,
          employerPostalCode: response.data.employerDetails.address.postCode,
          employerAddressLine1: response.data.employerDetails.address.addressLine1,
          employerAddressLine2: response.data.employerDetails.address.addressLine2,
          employerOrganisation: response.data.employerDetails.address.organization,
          employerMap: response.data.employerDetails.mapLink,
          applicationUrl: response.data.apply.url,
          applicationEmail: response.data.apply.email,
          applicationFormat: response.data.apply.format,
          applicationInstructions: response.data.apply.additionalInstructions,
          interview: response.data.interview
        });
      });
  }

  async getApprenticeship(slug) {
    return axios.get(`${config.endpoints.apprenticeships}/${slug}`, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
      .catch(error => {
        this.setState({
          isLoadingApprenticeship: error.response.status
        })
      });
  }

  render() {
    const id = this.props.params.apprenticeship.split('-').pop();
    const slug = this.props.params.apprenticeship;



    return <HandleLoading loading={{isLoadingApprenticeship:this.state.isLoadingApprenticeship}} messages={this.state.messages} container={true}>
      <DetailView {...this.props} {...this.state} id={id} slug={slug} />
    </HandleLoading>;
  }
}

DetailController.contextType = OptionsContext;

export default withRouter(withError(DetailController));
